/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AgreementAppendix } from './AgreementAppendix'

export class ParagraphAgreement {
  constructor(json: JSON | any) {
    Object.assign(this as ParagraphAgreement, json)
  }

  timestamp?: number
  paragraph?: string
  accepted?: boolean
  inTreatment?: boolean
  canceled?: boolean
  careProviderReference?: string
  decisionReference?: string
  start?: number
  end?: number
  cancelationDate?: number
  quantityValue?: number
  quantityUnit?: string
  ioRequestReference?: string
  responseType?: string
  refusalJustification?: { [key: string]: string }
  verses?: Array<number>
  coverageType?: string
  unitNumber?: number
  strength?: number
  strengthUnit?: string
  agreementAppendices?: Array<AgreementAppendix>
  documentId?: string
}
